
import { put, call, takeEvery, select, takeLatest } from 'redux-saga/effects';
import * as actions from './actions';
import { Endpoints } from 'services/api';
import errorHandler from 'common/errorHandler';

const getTenant = (state) => state.userLogin.tenant;

function* getEventBusinessArea(api, tenantId, eventId, businessAreaId) {
    try {
        let result = yield call([api, api.get], `${Endpoints.events}/api/v1/events/${eventId}/businessareas/${businessAreaId}`, { tenantid: tenantId });
        return result.data;
    }
    catch (error) {
        if (error.isAxiosError) {
            if (error.response && error.response.status === 404) {
                return null;
            }
        }
        throw error;
    }
}

export function* getEventBusinessAreaRequest(api, { eventId, businessAreaId }) {
    try {
        let tenant = yield select(getTenant);
        const businessAreaRevision = yield call(getEventBusinessArea, api, tenant.tenantId, eventId, businessAreaId);
        yield put(actions.getEventBusinessAreaSuccess(businessAreaRevision));
    } catch (error) {
        let errorObject = errorHandler(error, "Get", "event business area details");
        yield put(actions.getEventBusinessAreaFailure(errorObject));
    }
}

export function* watchGetEventBusinessAreaRequest(api, { params }) {
    yield call(getEventBusinessAreaRequest, api, params);
}

export default function* ({ api }) {
    yield takeLatest(actions.GET_EVENT_BUSINESS_AREA_REQUEST, watchGetEventBusinessAreaRequest, api);
}